// Copyright (c) 2016 Deere & Company

import Dealer from '../../../../sharedmodules/state/dealer';
import t from 'tcomb';

const Dealers = t.list(Dealer, 'Dealers');

export const getDefaultState = () => new Dealers([]);

export default Dealers;
